import Vue from 'vue';
import Vuex from 'vuex';
import VueAuthenticateInstance from '@/services/auth.js';

export default new Vuex.Store({
    state: {
        isAuthenticated: false,
        profile: {},
        term: {id: localStorage.getItem('termID')}
    },
    getters: {
        isAuthenticated() {
            return VueAuthenticateInstance.isAuthenticated();
        },
        profile(state) {
            return state.profile;
        },
        term(state) {
            return state.term;
        }
    },
    mutations: {
        authenticate(state, payload) {
            state.isAuthenticated = payload.isAuthenticated;
        },
        profile(state, payload) {
            state.profile = payload;
        },
        term(state, payload) {
            state.term = payload;
            localStorage.setItem('termID', payload.id);
        }
    },
    actions: {
        login(context, payload) {
            payload || {};
            return VueAuthenticateInstance.login(payload.user, payload.requestOptions).then(response => {
                if (response.status === 200 && response.data.status) {
                    context.commit('authenticate', {
                        isAuthenticated: VueAuthenticateInstance.isAuthenticated()
                    });
                    context.commit('profile', response.data.user);
                    return response;
                }
                return response.response;
            }).catch(error => {
                return error.response;
            });

        },
        logout(context, payload) {
            payload = payload || {};
            return VueAuthenticateInstance.logout(payload.requestOptions).then(function () {
                context.commit('authenticate', {
                    isAuthenticated: VueAuthenticateInstance.isAuthenticated()
                });
                context.commit('profile', {});
            });
        },
        setProfile(context, payload) {
            payload = payload || {};
            if (context.getters.isAuthenticated) {
                return Vue.axios.get(process.env.API_URL + '/user/profile', payload.requestOptions).then(response => {
                    if (response.status === 200 && response.data.status) {
                        context.commit('profile', response.data.data);
                        return response;
                    }
                    return response.response;
                });
            } else {
                context.commit('profile', {});
            }
        },
        setTerm(context, payload) {
            payload = payload || {};
            context.commit('term', payload);
        }

    }
})


// WEBPACK FOOTER //
// ./src/store.js